import { render, staticRenderFns } from "./register-popup.vue?vue&type=template&id=268a9ea7&"
import script from "./register-popup.vue?vue&type=script&lang=ts&"
export * from "./register-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('268a9ea7')) {
      api.createRecord('268a9ea7', component.options)
    } else {
      api.reload('268a9ea7', component.options)
    }
    module.hot.accept("./register-popup.vue?vue&type=template&id=268a9ea7&", function () {
      api.rerender('268a9ea7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/getting-discount/register-popup.vue"
export default component.exports